import { ReactElement } from 'react';
import type { Values } from '@fiverr-private/dropdown';
import { OptionProps } from './Option/types';

export const getSelectedOptionLabel = (values: Values, options: ReactElement<OptionProps>[]): string | undefined => {
    const valuesGroups = Object.values(values);

    if (valuesGroups.length === 1) {
        const firstGroupValue = valuesGroups[0];

        const isMulti = Array.isArray(firstGroupValue);

        if (!isMulti) {
            const selectedOption = options.find((option) => option?.props.value === firstGroupValue);
            return selectedOption?.props.children as string;
        }
    }
};
